import { render, staticRenderFns } from "./CacheStats.vue?vue&type=template&id=fe3a4dfe&"
import script from "./CacheStats.vue?vue&type=script&lang=js&"
export * from "./CacheStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports